import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.json.stringify.js";
import i18n from '@/lang/lang';
import { get14fSelectedApi, get14fDataApi, getLinkBlobApi } from '@/api';
import { numberThousandsComma as _numberThousandsComma } from '@/utils/numberThousandsComma';
import defaultImg from '@/assets/login_bg.jpg';

import { DateTime } from 'luxon';
import clonedeep from 'lodash.clonedeep';
var chartSetting = {
  chart: {
    height: 170,
    backgroundColor: 'transparent'
  },
  title: {
    text: ''
  },
  credits: {
    enabled: false
  },
  colors: ['#55abe6', '#3b88c9'],
  tooltip: {
    shared: true,
    borderColor: '#3b88c9',
    style: {
      letterSpacing: '1px'
    },
    distance: 20,
    followPointer: true
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    series: {
      label: {
        enabled: false
      },
      borderColor: '#55abe6',
      // default #fffff
      marker: {
        enabled: false,
        radius: 4,
        // 圖例大小
        states: {
          hover: {
            radiusPlus: 1
          }
        }
      }
    }
  },
  yAxis: [{
    title: {
      text: ''
    } // 發電量 (kWh)
  }, {
    title: {
      text: ''
    },
    // 售電金額 (NTD)
    opposite: true,
    gridLineColor: '#87bae6'
  }]
};
var dataChart = _objectSpread(_objectSpread({}, chartSetting), {}, {
  xAxis: {
    categories: [],
    // 根據 api data 填入
    lineColor: '#87bae6'
  },
  series: [{
    name: '發電量',
    type: 'column',
    yAxis: 0,
    data: [],
    // 根據 api data 填入
    tooltip: {
      valueSuffix: ' 度'
    }
  }, {
    name: '售電金額',
    type: 'spline',
    yAxis: 1,
    data: [],
    // 根據 api data 填入
    tooltip: {
      valueSuffix: ' 元'
    }
  }]
});
export default {
  name: 'TvWallLooping',
  data: function data() {
    return {
      today: DateTime.now().toFormat('MM/dd'),
      updateTime: DateTime.now().toFormat('y/MM/dd HH:mm:ss'),
      isLoadingData: true,
      isData4Show: true,
      isData5Show: true,
      isData6Show: true,
      isData7Show: true,
      isData8Show: true,
      isData9Show: true,
      isUpdateTimeShow: true,
      intervalDataId: null,
      dataTimeInterval: 60000,
      // 此時展示的 data index -> 取得 next index to call api 、 imageMap.get
      nowDataIndex: 0,
      factoryNameList: [],
      allData: {
        wholeData: {},
        singleData: {},
        weatherData: {}
      },
      showFactoryImageMap: new Map(),
      // key: fId, value: imageList
      preLoadAllData: {
        wholeData: {},
        singleData: {},
        weatherData: {}
      },
      showImageList: [defaultImg],
      imageTimeInterval: 60000,
      slideIndex: 0,
      data4: {},
      data7: {
        address: '',
        desc: '',
        tempRangeDesc: '',
        rain: 0,
        clouds: 0,
        imgUrl: '',
        weekDayList: [
          // { weekDay: '星期一', imgUrl: '', tempRange: '' }, ...
        ]
      },
      data6: {
        dayKwhSum: 0,
        daySellPriceSum: 0,
        chart: clonedeep(dataChart)
      },
      data8: {
        monKwhSum: 0,
        monSellPriceSum: 0,
        chart: clonedeep(dataChart)
      },
      data9: {
        yearKwhSum: 0,
        yearSellPriceSum: 0,
        chart: clonedeep(dataChart)
      }
    };
  },
  computed: {
    nextCallDataIndex: function nextCallDataIndex() {
      var _this$factoryNameList;
      var nextIdx = this.nowDataIndex + 1;
      return nextIdx > ((_this$factoryNameList = this.factoryNameList) === null || _this$factoryNameList === void 0 ? void 0 : _this$factoryNameList.length) - 1 ? 0 : nextIdx;
    },
    singleData: function singleData() {
      var _this$allData;
      return (_this$allData = this.allData) === null || _this$allData === void 0 ? void 0 : _this$allData.singleData;
    },
    weatherDataCurrent: function weatherDataCurrent() {
      var _this$allData2, _this$allData2$weathe;
      return (_this$allData2 = this.allData) === null || _this$allData2 === void 0 ? void 0 : (_this$allData2$weathe = _this$allData2.weatherData) === null || _this$allData2$weathe === void 0 ? void 0 : _this$allData2$weathe.current;
    },
    weatherDataDaily: function weatherDataDaily() {
      var _this$allData3, _this$allData3$weathe;
      return (_this$allData3 = this.allData) === null || _this$allData3 === void 0 ? void 0 : (_this$allData3$weathe = _this$allData3.weatherData) === null || _this$allData3$weathe === void 0 ? void 0 : _this$allData3$weathe.daily;
    },
    data2: function data2() {
      var _this$allData4;
      var wholeData = (_this$allData4 = this.allData) === null || _this$allData4 === void 0 ? void 0 : _this$allData4.wholeData;
      var todayPowerSum = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : wholeData.daySumKw) ? _numberThousandsComma(Math.round((wholeData === null || wholeData === void 0 ? void 0 : wholeData.daySumKw) * 1000)) : '--';
      var monthPowerSum = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : wholeData.monSumKw) ? _numberThousandsComma(Math.round((wholeData === null || wholeData === void 0 ? void 0 : wholeData.monSumKw) * 1000)) : '--';
      var yearPowerSum = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : wholeData.yearSumKw) ? _numberThousandsComma(Math.round((wholeData === null || wholeData === void 0 ? void 0 : wholeData.yearSumKw) * 1000)) : '--';
      return {
        todayPowerSum: todayPowerSum,
        monthPowerSum: monthPowerSum,
        yearPowerSum: yearPowerSum
      };
    },
    data3: function data3() {
      var _this$allData5, _wholeData$totalFacto, _wholeData$north$coun, _wholeData$north, _wholeData$north2, _wholeData$north3, _wholeData$mid$count, _wholeData$mid, _wholeData$mid2, _wholeData$mid3, _wholeData$south$coun, _wholeData$south, _wholeData$south2, _wholeData$south3;
      var wholeData = (_this$allData5 = this.allData) === null || _this$allData5 === void 0 ? void 0 : _this$allData5.wholeData;
      var siteTotal = (_wholeData$totalFacto = wholeData === null || wholeData === void 0 ? void 0 : wholeData.totalFactoriesCount) !== null && _wholeData$totalFacto !== void 0 ? _wholeData$totalFacto : '--';
      var capacityTotal = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : wholeData.totalFactoriesCapMw) ? Math.round((wholeData === null || wholeData === void 0 ? void 0 : wholeData.totalFactoriesCapMw) * 100) / 100 : '--';
      var northSiteTotal = (_wholeData$north$coun = wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$north = wholeData.north) === null || _wholeData$north === void 0 ? void 0 : _wholeData$north.count) !== null && _wholeData$north$coun !== void 0 ? _wholeData$north$coun : '--';
      var northCapacityTotal = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$north2 = wholeData.north) === null || _wholeData$north2 === void 0 ? void 0 : _wholeData$north2.capMw) ? Math.round((wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$north3 = wholeData.north) === null || _wholeData$north3 === void 0 ? void 0 : _wholeData$north3.capMw) * 100) / 100 : '--';
      var midSiteTotal = (_wholeData$mid$count = wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$mid = wholeData.mid) === null || _wholeData$mid === void 0 ? void 0 : _wholeData$mid.count) !== null && _wholeData$mid$count !== void 0 ? _wholeData$mid$count : '--';
      var midCapacityTotal = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$mid2 = wholeData.mid) === null || _wholeData$mid2 === void 0 ? void 0 : _wholeData$mid2.capMw) ? Math.round((wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$mid3 = wholeData.mid) === null || _wholeData$mid3 === void 0 ? void 0 : _wholeData$mid3.capMw) * 100) / 100 : '--';
      var southSiteTotal = (_wholeData$south$coun = wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$south = wholeData.south) === null || _wholeData$south === void 0 ? void 0 : _wholeData$south.count) !== null && _wholeData$south$coun !== void 0 ? _wholeData$south$coun : '--';
      var southCapacityTotal = this.isNumber(wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$south2 = wholeData.south) === null || _wholeData$south2 === void 0 ? void 0 : _wholeData$south2.capMw) ? Math.round((wholeData === null || wholeData === void 0 ? void 0 : (_wholeData$south3 = wholeData.south) === null || _wholeData$south3 === void 0 ? void 0 : _wholeData$south3.capMw) * 100) / 100 : '--';
      return {
        siteTotal: siteTotal,
        capacityTotal: capacityTotal,
        northSiteTotal: northSiteTotal,
        northCapacityTotal: northCapacityTotal,
        midSiteTotal: midSiteTotal,
        midCapacityTotal: midCapacityTotal,
        southSiteTotal: southSiteTotal,
        southCapacityTotal: southCapacityTotal
      };
    }
  },
  methods: {
    numberThousandsComma: function numberThousandsComma(num) {
      return _numberThousandsComma(num);
    },
    extractNumber: function extractNumber(inputString) {
      if (inputString) {
        // 使用正則表達式匹配數字和小數點
        var match = inputString.match(/(\d+(\.\d+)?)\s*k?Wp/i);

        // 如果找到匹配，則提取數字部分，否則返回 inputString
        return match ? parseFloat(match[1]) : inputString;
      }
      return inputString;
    },
    resizeCharts: function resizeCharts() {
      var _this = this;
      // chart height
      this.$nextTick(function () {
        var refPowerBlockHeight = _this.$refs.refTodayPower.getBoundingClientRect().height;
        _this.data6.chart.chart.height = refPowerBlockHeight * 0.7;
        _this.data8.chart.chart.height = refPowerBlockHeight * 0.7;
        _this.data9.chart.chart.height = refPowerBlockHeight * 0.7;
      });
    },
    toggleSetInterval: function toggleSetInterval() {
      if (document.hidden) {
        // 頁面不可見
        window.clearInterval(this.intervalDataId);
        this.intervalDataId = null;
      } else {
        // 頁面可見
        // setInterval -> looping data
        this.setIntervalDataId();
      }
    },
    setIntervalDataId: function setIntervalDataId() {
      var _this2 = this;
      // 設定時間間格 翻 card，翻 (isDataShow false) -> 更新資料(updateData) -> 翻完 (isDataShow true)
      // isDataShow false 轉場 -> 更新 data (preLoadData 載進 allData) -> isDataShow true (幾乎同時 set data 更新展示下個 data)
      this.intervalDataId = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isData4Show = false; // transition leave
                _context.next = 3;
                return _this2.delay(0.2);
              case 3:
                _this2.isData5Show = false;
                _context.next = 6;
                return _this2.delay(0.2);
              case 6:
                _this2.isData6Show = false;
                _context.next = 9;
                return _this2.delay(0.2);
              case 9:
                _this2.isData7Show = false;
                _context.next = 12;
                return _this2.delay(0.2);
              case 12:
                _this2.isData8Show = false;
                _context.next = 15;
                return _this2.delay(0.2);
              case 15:
                _this2.isData9Show = false;
                _context.next = 18;
                return _this2.delay(0.2);
              case 18:
                _this2.isUpdateTimeShow = false;
                _context.next = 21;
                return _this2.updateData();
              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), this.dataTimeInterval);
    },
    delay: function delay(s) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, s * 1000);
      });
    },
    isNumber: function isNumber(value) {
      return typeof value === 'number' && !isNaN(value);
    },
    changeNowDataIndex: function changeNowDataIndex() {
      var _this$factoryNameList2;
      // 若超過 name list 數 則跳回 index 0
      var nextIdx = this.nowDataIndex + 1;
      if (nextIdx > ((_this$factoryNameList2 = this.factoryNameList) === null || _this$factoryNameList2 === void 0 ? void 0 : _this$factoryNameList2.length) - 1) {
        this.nowDataIndex = 0;
      } else {
        this.nowDataIndex++;
      }
    },
    setData5: function setData5() {
      var _this$showFactoryImag, _this$singleData, _this$singleData2;
      // 顯示第一個案場輪播照片第一張 (顯示第 idx 0 照片)
      this.slideIndex = 0;
      this.showImageList = (_this$showFactoryImag = this.showFactoryImageMap.get((_this$singleData = this.singleData) === null || _this$singleData === void 0 ? void 0 : _this$singleData.fId)) !== null && _this$showFactoryImag !== void 0 && _this$showFactoryImag.length ? this.showFactoryImageMap.get((_this$singleData2 = this.singleData) === null || _this$singleData2 === void 0 ? void 0 : _this$singleData2.fId) : [defaultImg];

      // 一分鐘輪播內 有幾張照片 就播幾張: 60s/照片數
      this.imageTimeInterval = this.dataTimeInterval / this.showImageList.length;
    },
    setData6: function setData6() {
      var _this$singleData3, _this$singleData4, _this$singleData4$day, _this$singleData5, _this$singleData5$day, _this$singleData6, _this$singleData6$day, _this$singleData7, _this$singleData7$day, _this$singleData8, _this$singleData8$day;
      // 今日 發電量、售電金額
      this.data6.dayKwhSum = _numberThousandsComma(Math.round(((_this$singleData3 = this.singleData) === null || _this$singleData3 === void 0 ? void 0 : _this$singleData3.dayKwhSum) * 10) / 10);
      this.data6.daySellPriceSum = _numberThousandsComma(Math.round((_this$singleData4 = this.singleData) === null || _this$singleData4 === void 0 ? void 0 : (_this$singleData4$day = _this$singleData4.dayKwh) === null || _this$singleData4$day === void 0 ? void 0 : _this$singleData4$day.reduce(function (acc, cur) {
        return acc + (cur === null || cur === void 0 ? void 0 : cur.sellPrice);
      }, 0)));

      // chart 時 list
      this.data6.chart.xAxis.categories = Array.from({
        length: 24
      }, function (_v, i) {
        return String(i).padStart(2, '0') + ':00';
      });

      // chart 發電量
      this.data6.chart.series[0].data = (_this$singleData5 = this.singleData) === null || _this$singleData5 === void 0 ? void 0 : (_this$singleData5$day = _this$singleData5.dayKwh) === null || _this$singleData5$day === void 0 ? void 0 : _this$singleData5$day.map(function (obj) {
        return Math.round(obj.kWh * 10) / 10;
      }).concat(Array(24 - ((_this$singleData6 = this.singleData) === null || _this$singleData6 === void 0 ? void 0 : (_this$singleData6$day = _this$singleData6.dayKwh) === null || _this$singleData6$day === void 0 ? void 0 : _this$singleData6$day.length)).fill(null));

      // chart 售電金額
      this.data6.chart.series[1].data = (_this$singleData7 = this.singleData) === null || _this$singleData7 === void 0 ? void 0 : (_this$singleData7$day = _this$singleData7.dayKwh) === null || _this$singleData7$day === void 0 ? void 0 : _this$singleData7$day.map(function (obj) {
        return Math.round(obj === null || obj === void 0 ? void 0 : obj.sellPrice);
      }).concat(Array(24 - ((_this$singleData8 = this.singleData) === null || _this$singleData8 === void 0 ? void 0 : (_this$singleData8$day = _this$singleData8.dayKwh) === null || _this$singleData8$day === void 0 ? void 0 : _this$singleData8$day.length)).fill(null));
    },
    setData8: function setData8() {
      var _this$singleData9, _this$singleData10, _this$singleData10$mo, _this$singleData11, _this$singleData11$mo, _this$singleData12, _this$singleData12$mo, _this$singleData13, _this$singleData13$mo, _this$singleData14, _this$singleData14$mo;
      // 本月 發電量、售電金額
      this.data8.monKwhSum = _numberThousandsComma(Math.round(((_this$singleData9 = this.singleData) === null || _this$singleData9 === void 0 ? void 0 : _this$singleData9.monKwhSum) * 10) / 10);
      this.data8.monSellPriceSum = _numberThousandsComma(Math.round((_this$singleData10 = this.singleData) === null || _this$singleData10 === void 0 ? void 0 : (_this$singleData10$mo = _this$singleData10.monKwh) === null || _this$singleData10$mo === void 0 ? void 0 : _this$singleData10$mo.reduce(function (acc, cur) {
        return acc + (cur === null || cur === void 0 ? void 0 : cur.sellPrice);
      }, 0)));

      // chart 日 list
      this.data8.chart.xAxis.categories = Array.from({
        length: DateTime.local().daysInMonth
      }, function (_, i) {
        return String(DateTime.local().month).padStart(2, '0') + '/' + String(i + 1).padStart(2, '0');
      });

      // chart 發電量
      this.data8.chart.series[0].data = (_this$singleData11 = this.singleData) === null || _this$singleData11 === void 0 ? void 0 : (_this$singleData11$mo = _this$singleData11.monKwh) === null || _this$singleData11$mo === void 0 ? void 0 : _this$singleData11$mo.map(function (obj) {
        return Math.round(obj.kWh * 10) / 10;
      }).concat(Array(DateTime.local().daysInMonth - ((_this$singleData12 = this.singleData) === null || _this$singleData12 === void 0 ? void 0 : (_this$singleData12$mo = _this$singleData12.monKwh) === null || _this$singleData12$mo === void 0 ? void 0 : _this$singleData12$mo.length)).fill(null));

      // chart 售電金額
      this.data8.chart.series[1].data = (_this$singleData13 = this.singleData) === null || _this$singleData13 === void 0 ? void 0 : (_this$singleData13$mo = _this$singleData13.monKwh) === null || _this$singleData13$mo === void 0 ? void 0 : _this$singleData13$mo.map(function (obj) {
        return Math.round(obj === null || obj === void 0 ? void 0 : obj.sellPrice);
      }).concat(Array(DateTime.local().daysInMonth - ((_this$singleData14 = this.singleData) === null || _this$singleData14 === void 0 ? void 0 : (_this$singleData14$mo = _this$singleData14.monKwh) === null || _this$singleData14$mo === void 0 ? void 0 : _this$singleData14$mo.length)).fill(null));
    },
    setData9: function setData9() {
      var _this$singleData15, _this$singleData16, _this$singleData16$ye, _this$singleData17, _this$singleData17$ye, _this$singleData18, _this$singleData18$ye, _this$singleData19, _this$singleData19$ye, _this$singleData20, _this$singleData20$ye;
      // 今年 發電量、售電金額
      this.data9.yearKwhSum = _numberThousandsComma(Math.round(((_this$singleData15 = this.singleData) === null || _this$singleData15 === void 0 ? void 0 : _this$singleData15.yearKwhSum) * 10) / 10);
      this.data9.yearSellPriceSum = _numberThousandsComma(Math.round((_this$singleData16 = this.singleData) === null || _this$singleData16 === void 0 ? void 0 : (_this$singleData16$ye = _this$singleData16.yearKwh) === null || _this$singleData16$ye === void 0 ? void 0 : _this$singleData16$ye.reduce(function (acc, cur) {
        return acc + (cur === null || cur === void 0 ? void 0 : cur.sellPrice);
      }, 0)));

      // chart 月 list
      this.data9.chart.xAxis.categories = Array.from({
        length: 12
      }, function (_v, i) {
        return "".concat(i + 1, "\u6708");
      });

      // chart 發電量
      this.data9.chart.series[0].data = (_this$singleData17 = this.singleData) === null || _this$singleData17 === void 0 ? void 0 : (_this$singleData17$ye = _this$singleData17.yearKwh) === null || _this$singleData17$ye === void 0 ? void 0 : _this$singleData17$ye.map(function (obj) {
        return Math.round(obj.kWh * 10) / 10;
      }).concat(Array(12 - ((_this$singleData18 = this.singleData) === null || _this$singleData18 === void 0 ? void 0 : (_this$singleData18$ye = _this$singleData18.yearKwh) === null || _this$singleData18$ye === void 0 ? void 0 : _this$singleData18$ye.length)).fill(null));

      // chart 售電金額
      this.data9.chart.series[1].data = (_this$singleData19 = this.singleData) === null || _this$singleData19 === void 0 ? void 0 : (_this$singleData19$ye = _this$singleData19.yearKwh) === null || _this$singleData19$ye === void 0 ? void 0 : _this$singleData19$ye.map(function (obj) {
        return Math.round(obj === null || obj === void 0 ? void 0 : obj.sellPrice);
      }).concat(Array(12 - ((_this$singleData20 = this.singleData) === null || _this$singleData20 === void 0 ? void 0 : (_this$singleData20$ye = _this$singleData20.yearKwh) === null || _this$singleData20$ye === void 0 ? void 0 : _this$singleData20$ye.length)).fill(null));
    },
    setData7: function setData7() {
      var _this$weatherDataCurr, _this$weatherDataCurr2, _this$weatherDataCurr3, _this$weatherDataDail, _this$singleData$addr, _this$singleData21, _this$singleData21$ad, _this$singleData21$ad2, _this$weatherDataCurr4, _this$weatherDataCurr5, _this$weatherDataCurr6, _this$weatherDataCurr7, _this$weatherDataDail2, _this$weatherDataDail3, _this$weatherDataDail4, _this$weatherDataDail5, _this$weatherDataDail6, _this$weatherDataDail7, _this$weatherDataDail8, _this$weatherDataDail9, _this$weatherDataDail10, _this$weatherDataCurr8, _this$weatherDataCurr9, _this$weatherDataCurr10, _this$weatherDataCurr11;
      var imgIconNo = (_this$weatherDataCurr = this.weatherDataCurrent) === null || _this$weatherDataCurr === void 0 ? void 0 : (_this$weatherDataCurr2 = _this$weatherDataCurr.weather) === null || _this$weatherDataCurr2 === void 0 ? void 0 : (_this$weatherDataCurr3 = _this$weatherDataCurr2[0]) === null || _this$weatherDataCurr3 === void 0 ? void 0 : _this$weatherDataCurr3.icon;
      var hasWeatherDataDaily = !!((_this$weatherDataDail = this.weatherDataDaily) !== null && _this$weatherDataDail !== void 0 && _this$weatherDataDail.length);
      this.data7 = {
        address: (_this$singleData$addr = (_this$singleData21 = this.singleData) === null || _this$singleData21 === void 0 ? void 0 : (_this$singleData21$ad = _this$singleData21.address) === null || _this$singleData21$ad === void 0 ? void 0 : (_this$singleData21$ad2 = _this$singleData21$ad.split(' ')) === null || _this$singleData21$ad2 === void 0 ? void 0 : _this$singleData21$ad2[0]) !== null && _this$singleData$addr !== void 0 ? _this$singleData$addr : '--',
        desc: (_this$weatherDataCurr4 = (_this$weatherDataCurr5 = this.weatherDataCurrent) === null || _this$weatherDataCurr5 === void 0 ? void 0 : (_this$weatherDataCurr6 = _this$weatherDataCurr5.weather) === null || _this$weatherDataCurr6 === void 0 ? void 0 : (_this$weatherDataCurr7 = _this$weatherDataCurr6[0]) === null || _this$weatherDataCurr7 === void 0 ? void 0 : _this$weatherDataCurr7.description) !== null && _this$weatherDataCurr4 !== void 0 ? _this$weatherDataCurr4 : '--',
        tempRangeDesc: this.isNumber((_this$weatherDataDail2 = this.weatherDataDaily) === null || _this$weatherDataDail2 === void 0 ? void 0 : (_this$weatherDataDail3 = _this$weatherDataDail2[0]) === null || _this$weatherDataDail3 === void 0 ? void 0 : (_this$weatherDataDail4 = _this$weatherDataDail3.temp) === null || _this$weatherDataDail4 === void 0 ? void 0 : _this$weatherDataDail4.min) ? "".concat(Math.round((_this$weatherDataDail5 = this.weatherDataDaily) === null || _this$weatherDataDail5 === void 0 ? void 0 : (_this$weatherDataDail6 = _this$weatherDataDail5[0]) === null || _this$weatherDataDail6 === void 0 ? void 0 : (_this$weatherDataDail7 = _this$weatherDataDail6.temp) === null || _this$weatherDataDail7 === void 0 ? void 0 : _this$weatherDataDail7.min), "\xB0 - ").concat(Math.round((_this$weatherDataDail8 = this.weatherDataDaily) === null || _this$weatherDataDail8 === void 0 ? void 0 : (_this$weatherDataDail9 = _this$weatherDataDail8[0]) === null || _this$weatherDataDail9 === void 0 ? void 0 : (_this$weatherDataDail10 = _this$weatherDataDail9.temp) === null || _this$weatherDataDail10 === void 0 ? void 0 : _this$weatherDataDail10.max), "\xB0") : '--',
        rain: (_this$weatherDataCurr8 = this.weatherDataCurrent) === null || _this$weatherDataCurr8 === void 0 ? void 0 : (_this$weatherDataCurr9 = _this$weatherDataCurr8.rain) === null || _this$weatherDataCurr9 === void 0 ? void 0 : _this$weatherDataCurr9['3h'],
        clouds: (_this$weatherDataCurr10 = this.weatherDataCurrent) === null || _this$weatherDataCurr10 === void 0 ? void 0 : (_this$weatherDataCurr11 = _this$weatherDataCurr10.clouds) === null || _this$weatherDataCurr11 === void 0 ? void 0 : _this$weatherDataCurr11.all,
        imgUrl: imgIconNo ? require("../assets/weather/".concat(imgIconNo, ".png")) : '',
        // 一周氣象資訊列表
        weekDayList: hasWeatherDataDaily ? this.weatherDataDaily.map(function (obj) {
          return {
            weekday: i18n.t("weekday.".concat(DateTime.fromSeconds(obj.dt).toFormat('cccc'))),
            imgUrl: require("../assets/weather/".concat(obj.weather[0].icon, ".png")),
            tempRange: "".concat(Math.round(obj.temp.min), "\xB0 - ").concat(Math.round(obj.temp.max), "\xB0")
          };
        }) : []
      };
    },
    updateData: function updateData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // preLoadData to allData
                _this3.allData = _objectSpread({}, _this3.preLoadAllData);
                _this3.changeNowDataIndex(); // 更新即將展示的 data index

                // show & set data
                // (翻轉出現時 才更新 data，才不會跳 next data 才翻轉出現)
                _this3.isData4Show = true; // transition enter
                _this3.data4 = _this3.singleData;
                _context2.next = 6;
                return _this3.delay(0.2);
              case 6:
                _this3.isData5Show = true;
                _this3.setData5();
                _context2.next = 10;
                return _this3.delay(0.2);
              case 10:
                _this3.isData6Show = true;
                _this3.setData6();
                _context2.next = 14;
                return _this3.delay(0.2);
              case 14:
                _this3.isData7Show = true;
                _this3.setData7();
                _context2.next = 18;
                return _this3.delay(0.2);
              case 18:
                _this3.isData8Show = true;
                _this3.setData8();
                _context2.next = 22;
                return _this3.delay(0.2);
              case 22:
                _this3.isData9Show = true;
                _this3.setData9();
                _context2.next = 26;
                return _this3.delay(0.2);
              case 26:
                _this3.isUpdateTimeShow = true;
                _this3.updateTime = DateTime.now().toFormat('y/MM/dd HH:mm:ss'); // 更新資料時間
                _context2.next = 30;
                return _this3.getPreLoad14fData();
              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    get14fSelectedFactoryNameList: function get14fSelectedFactoryNameList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return get14fSelectedApi();
              case 3:
                res = _context3.sent;
                if (res.data.success) {
                  _this4.factoryNameList = res.data.data;
                }
                _context3.next = 11;
                break;
              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                _this4.$swal('案場列表載入異常，請重新整理或洽網站管理員');
                console.log('get14fSelectedFactoryNameList', _context3.t0);
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    get14fData: function get14fData(factoryName) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _res$data, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return get14fDataApi(factoryName);
              case 3:
                res = _context4.sent;
                if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success) {
                  _this5.allData = res.data.data;
                }
                _context4.next = 11;
                break;
              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                _this5.$swal.fire({
                  text: "".concat(factoryName, " \u6848\u5834\u8CC7\u8A0A\u8F09\u5165\u7570\u5E38\uFF0C\u8ACB\u901A\u77E5\u7DB2\u7AD9\u7BA1\u7406\u54E1"),
                  icon: 'warning',
                  showConfirmButton: false,
                  timer: 3000
                });
                _this5.errorStorage(factoryName, _context4.t0);
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 7]]);
      }))();
    },
    getFactoryImageLinkList: function getFactoryImageLinkList(id) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _res$data2, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return getLinkBlobApi(id);
              case 3:
                res = _context5.sent;
                if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.success) {
                  _this6.showFactoryImageMap.set(id, res.data.data);
                }
                _context5.next = 11;
                break;
              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                _this6.$swal('案場圖片載入異常，請重新整理或洽網站管理員');
                console.log('getFactoryImageLinkList', _context5.t0);
              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }))();
    },
    getPreLoad14fData: function getPreLoad14fData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var nextFactoryName, _res$data3, _res$data4, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                nextFactoryName = _this7.factoryNameList[_this7.nextCallDataIndex];
                _context6.prev = 1;
                _context6.next = 4;
                return get14fDataApi(nextFactoryName);
              case 4:
                res = _context6.sent;
                if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.success) {
                  _this7.preLoadAllData = res.data.data;
                } else {
                  _this7.preLoadAllData = {
                    wholeData: {},
                    singleData: {},
                    weatherData: {}
                  };
                }

                // 最新 preLoadAllData fid 取得 案場輪播照片清單
                // check showFactoryImageMap 是否已有下個要 call 的案場的照片
                // 只有在 get14fDataApi 成功時才取得 LinkBlobApi
                if (!(!_this7.showFactoryImageMap.get(_this7.preLoadAllData.singleData.fId) && res !== null && res !== void 0 && (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.success && _this7.preLoadAllData.singleData.fId)) {
                  _context6.next = 9;
                  break;
                }
                _context6.next = 9;
                return _this7.getFactoryImageLinkList(_this7.preLoadAllData.singleData.fId);
              case 9:
                _context6.next = 16;
                break;
              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);
                _this7.preLoadAllData = {
                  wholeData: {},
                  singleData: {},
                  weatherData: {}
                };
                _this7.$swal.fire({
                  text: "".concat(nextFactoryName, " \u6848\u5834\u8CC7\u8A0A\u9810\u8F09\u7570\u5E38\uFF0C\u8ACB\u901A\u77E5\u7DB2\u7AD9\u7BA1\u7406\u54E1"),
                  icon: 'warning',
                  showConfirmButton: false,
                  timer: 3000
                });
                _this7.errorStorage(nextFactoryName, _context6.t0);
              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 11]]);
      }))();
    },
    errorStorage: function errorStorage(factoryName, errorMsg) {
      var time = DateTime.now().toFormat('y/MM/dd HH:mm:ss');
      // error 記錄 localStorage
      var hasTvWallErrorObj = JSON.parse(localStorage.getItem('TvWallError'));
      if (hasTvWallErrorObj) {
        var setErrorMsg = {
          error: hasTvWallErrorObj.error.concat("".concat(factoryName, "__").concat(time, "__").concat(errorMsg))
        };
        localStorage.setItem('TvWallError', JSON.stringify(setErrorMsg));
      } else {
        var _setErrorMsg = {
          error: ["".concat(factoryName, "__").concat(time, "__").concat(errorMsg)]
        };
        localStorage.setItem('TvWallError', JSON.stringify(_setErrorMsg));
      }
    }
  },
  created: function created() {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              window.addEventListener('resize', _this8.resizeCharts);
              window.addEventListener('visibilitychange', _this8.toggleSetInterval);

              // get data
              // 1. 取得可展示案場名稱列表
              _context7.next = 4;
              return _this8.get14fSelectedFactoryNameList();
            case 4:
              _context7.next = 6;
              return _this8.get14fData(_this8.factoryNameList[_this8.nowDataIndex]);
            case 6:
              if (!_this8.allData.singleData.fId) {
                _context7.next = 9;
                break;
              }
              _context7.next = 9;
              return _this8.getFactoryImageLinkList(_this8.allData.singleData.fId);
            case 9:
              // set data
              _this8.data4 = _this8.singleData;
              _this8.setData5();
              _this8.setData6();
              _this8.setData7();
              _this8.setData8();
              _this8.setData9();

              // show data
              _this8.isLoadingData = false;

              // setInterval -> looping data
              _this8.setIntervalDataId();

              // 預載 next data
              _context7.next = 19;
              return _this8.getPreLoad14fData();
            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts);
    window.removeEventListener('visibilitychange', this.toggleSetInterval);
    window.clearInterval(this.intervalDataId);
    this.intervalDataId = null;
    localStorage.removeItem('TvWallError');
  }
};